var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"text-preview"},[_c('p',{staticClass:"text-preview-label"},[_vm._v(_vm._s(_vm.props.label))]),_c('div',{staticClass:"text-preview-content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }